export default {
    isOpen: false,
    hasBigShadow: true,
};
